/* Styled Components are hard code they will get from server once integrated */
import styled from "styled-components";
import { starz1 as theme } from "starz-visual-themes";
import { i18n } from "../../services/i18nService";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const PlayerDiv = styled.div`
  width: 100%;
  height: 100%;
`;

export const LowerPlayerControls = styled.div`
  width: 100%;
  height: 3.3em;
  position: absolute;
  margin-top: 51em;
  z-index: 9999;
`;

export const PlayPauseToggle = styled.a`
  margin-left: 6em;
`;

export const ToggleBtn = styled.svg.attrs({
  viewBox: theme.components.icon.viewBox
})`
  width: 2.5em;
  height: 2.5em;
  margin-top: 0.7em;
`;

export const FillBtnPlay = styled.path.attrs(props => ({
  d: theme.components.icon.list["play"].path
}))`
  fill: ${theme.color.grey};
  fill-opacity: 1;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

export const FillBtnPause = styled.path.attrs(props => ({
  d: theme.components.icon.list["pause"].path
}))`
  fill: ${theme.color.grey};
  fill-opacity: 1;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

export const CurrentPlay = styled.div`
  position: absolute;
  display: inline-table;
  margin-top: 1em;
  margin-left: 0.5em;
`;

export const TotalPlayTime = styled.div`
  position: absolute;
  display: inline-table;
  margin-top: 1em;
  margin-left: 79em;
`;

export const CurrentAndTotalPlaySpan = styled.span`
  font-weight: bold;
  font-family: sans-serif;
  font-size: ${theme.font.size.default};
  text-align: center;
  display: inline-block;
  color: ${theme.color.primary};
  margin: 0 ${theme.spacing.xsmall};
  flex-shrink: 0;
`;

export const ProgressBarContainer = styled.div`
  position: absolute;
  bottom: 14em;
  left: 14.55em;
  top: 1.7em;
  margin: 0 ${theme.spacing.xsmall};
  width: 72em;
  height: 0.42rem;
  border-style: none;
  border-radius: 2em;
`;

export const ProgressBar = styled.progress`
  height: 0.42rem;
  position: absolute;
  background-color: ${theme.color.greyDarkest};
  display: inline-block;
  top: 0;
  width: 72em;
  border-style: none;
  border-radius: 2em;
  z-index: ${theme.zIndex.base};
  ::-webkit-progress-value {
    background-color: ${theme.color.secondaryLight};
    border-style: none;
    border-radius: 2em;
  }
  ::-webkit-progress-bar {
    border-style: none;
    border-radius: 2em;
    background-color: ${theme.color.greyDarkest};
  }
`;

export const ControlsSettingsStyled = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  padding: ${theme.spacing.medium} ${theme.baseLayoutPaddingBs}%;
  z-index: ${theme.zIndex.base};
`;

export const LabelDiv = styled.div`
  position: absolute;
  width: 25em;
  height: 3em;
  top: 0;
  padding: 5.5rem 5%;
`;

export const LabelStyled = styled.span`
  display: inline-block;
  margin-left: ${theme.spacing.default};
  font-size: 1.6em;
  color: ${theme.color.primary};
  display: block;
  position: absolute;
  margin-top: 0.5em;
  opacity: 1;
  z-index: 11;
`;

export const ControlSettingsBtn = styled.svg.attrs({
  viewBox: theme.components.icon.viewBox
})`
  width: 2.5em;
  height: 2.5em;
  margin: 0 ${theme.spacing.xsmall} 0 ${theme.spacing.small};
`;

export const FillBtnBack = styled.path.attrs(props => ({
  d: theme.components.icon.list[i18n.getDirection() === "ltr" ? "arrowLeft" : "arrowRight"].path
}))`
  fill: ${theme.color.grey};
  fill-opacity: 1;
  z-index: 12;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

export const FillBtnLanguage = styled.path.attrs(props => ({
  d: theme.components.icon.list["language"].path
}))`
  fill: ${theme.color.grey};
  fill-opacity: 1;
  z-index: 12;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

export const FillBtnStart = styled.path.attrs(props => ({
  d: theme.components.icon.list["playBeginning"].path
}))`
  fill: ${theme.color.grey};
  fill-opacity: 1;
  z-index: 12;
  stroke-width: 0px;
  fill-rule: nonzero;
`;

export const FillBtnEpisode = styled.path.attrs(props => ({
  d: theme.components.icon.list["episodes"].path
}))`
  fill: ${theme.color.grey};
  fill-opacity: 1;
  z-index: 12;
  stroke-width: 0px;
  fill-rule: nonzero;
`;
